import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../client";

const BASE_URL = "shared/Screens";

export const getScreens = createAsyncThunk(
  "Screens/list",
  async () => (await api.get(BASE_URL)).data,
);

export const getScreen = createAsyncThunk(
  "Screens/get",
  async (id) => (await api.get(`${BASE_URL}/${id}`)).data,
);

export const saveScreen = createAsyncThunk(
  "Screens/save",
  async (data) => (await api.post(BASE_URL, data)).data,
);

export const updateScreen = createAsyncThunk(
  "Screens/update",
  async (data) => (await api.put(`${BASE_URL}/${data.id}`, data)).data,
);

export const deleteScreen = createAsyncThunk(
  "Screens/delete",
  async (id) => (await api.delete(`${BASE_URL}/${id}`)).data,
);

const addCases = (builder, thunk, onFulfilled) =>
  builder
    .addCase(thunk.pending, (state) => {
      state.isLoading = true;
      state.message = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.isLoading = false;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload ?? action.error.message;
    });

const initialState = {
  list: [],
  screen: null,
  isLoading: false,
  message: null,
};

const slice = createSlice({
  name: "screens",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCases(builder, getScreens, (state, action) => {
      state.list = action.payload.data;
    });
    addCases(builder, getScreen, (state, action) => {
      state.screen = action.payload.data;
    });
    addCases(builder, saveScreen, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, updateScreen, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, deleteScreen, (state, action) => {
      state.message = action.payload.message;
    });
  },
});

export default slice.reducer;
